import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { BusinessGroupResponse, BusinessGroupRequest, BusinessGroupsService } from '@src/app/shared/backend/clients';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-edit-business-group',
    templateUrl: './edit-business-group.component.html',
    styleUrl: './edit-business-group.component.scss',
    host: {
        class: 'app-edit-business-group'
    },
    standalone: false
})
export class EditBusinessGroupComponent extends BaseViewComponent implements OnInit {

  businessGroupId: number = 0;
  businessGroup: BusinessGroupResponse = {};

  totalRecords: number = 0;
  rowsPerPageOption: number = 5;
  usersList: string[] = [];

  public businessGroupForm: FormGroup = this.fb.group({
    name: ['', [Validators.required, Validators.maxLength(50)]],
    code: ['', [Validators.required, Validators.maxLength(50)]]
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private businessGroupsService: BusinessGroupsService,
    private fb: FormBuilder
  ) {
    super();
  }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    this.route.params.subscribe(async params => {
      this.businessGroupId = Number(params['businessGroupId']);

      console.log('this.businessGroupId', this.businessGroupId);

      if (this.businessGroupId) {
        await this.getBusinessGroupById();
      }
    });
  }

  async getBusinessGroupById() {
    this.businessGroup = await firstValueFrom(
      this.businessGroupsService.apiBusinessGroupsIdGet(this.businessGroupId)
    );

    this.initForm();
  }

  initForm() {
    this.businessGroupForm.controls['name'].setValue(this.businessGroup.name);
    this.businessGroupForm.controls['code'].setValue(this.businessGroup.code);
  }

  async submitForm() {
    if (this.businessGroupForm.valid) {
      const payload: BusinessGroupRequest = {
        name: this.businessGroupForm.controls['name'].value,
        code: this.businessGroupForm.controls['code'].value
      };

      await firstValueFrom(
        this.businessGroupsService.apiBusinessGroupsUpdateIdPut(this.businessGroupId, payload)
      );

      this.router.navigate(['/business-groups', this.businessGroupId]);
    }
  }
}
